exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Book-container-77Mvn {\n  max-width: var(--max-container-width);\n  margin: 40px auto 0 auto;\n}\n\n.Book-landingContainer-cZz6p {\n  width: 100%;\n  display: block;\n  margin: 0 auto;\n}\n\n@media screen and (max-width:767px) {\n  .Book-overFlowHiddenMobile-enRMC {\n    overflow-x: hidden;\n  }\n}", ""]);

// exports
exports.locals = {
	"container": "Book-container-77Mvn",
	"landingContainer": "Book-landingContainer-cZz6p",
	"overFlowHiddenMobile": "Book-overFlowHiddenMobile-enRMC"
};